import React, {useEffect, useCallback, useRef} from 'react';

export function ProgressSubmit({all = 0, done = 0, onSubmit}) {
  const refBar = useRef();

  const changeSticky = useCallback(() => {
    if (!refBar || !refBar.current) {
      return;
    }
    if (window.scrollY >= 50) {
      refBar.current.style.opacity = 1;
    } else {
      refBar.current.style.opacity = 0;
    }
  }, [refBar]);

  useEffect(() => {
    changeSticky();
    document.addEventListener('scroll', changeSticky);
    return () => document.removeEventListener('scroll', changeSticky);
  }, [changeSticky]);

  return <div className="progress" ref={refBar}>
    <div className="progress__container">
        <button className="info__form_btn" onClick={onSubmit}>Отправить</button>
    </div>
  </div>;
}
